import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-rentai-inquiry',
  templateUrl: './update-rentai-inquiry.component.html',
  styleUrls: ['./update-rentai-inquiry.component.css']
})
export class UpdateRentaiInquiryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/rentalInquiry/update-rentai-inquiry/update-rentai-inquiry.component.ts